import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api/";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const preferredModel = localStorage.getItem("preferredModel");
    if (preferredModel) {
      config.headers["x-model-override"] = preferredModel;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
